var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-page-search-wrapper"},[_c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"span":24}},[_c('site-asset-stock-list',{attrs:{"category":11}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }